import { Check } from "lucide-react";

const reasons = [
    "Acces la cele mai mari companii de asigurări, bănci și IFN-uri din România",
    "Consultanță 100% gratuită — nu plătești nimic în plus față de oferta directă",
    "Comparare obiectivă, fără a împinge produsul unei singure companii",
    "Suport în caz de daună — te ghidăm prin proces, pas cu pas",
    "Documentație gestionată integral de noi, tu doar semnezi",
    "Disponibili pe WhatsApp, email și telefon, inclusiv în weekend",
];

export default function About() {
    return (
        <section id="despre" data-testid="about-section" className="bg-[#fcfbf8] py-24 lg:py-32">
            <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12">
                <div className="lg:col-span-5">
                    <div className="text-xs uppercase tracking-[0.2em] text-[#0d3d2e]/60 mb-4">
                        03 — De ce noi
                    </div>
                    <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#0d3d2e] leading-[1.05] mb-8">
                        Asistenți,<br />nu agenți de vânzări.
                    </h2>
                    <p className="text-base lg:text-lg text-[#1a1a1a]/70 mb-6">
                        Ca echipă de asistenți în brokeraj autorizați, lucrăm pentru tine —
                        nu pentru o anumită companie. Misiunea noastră e simplă: să-ți punem la dispoziție
                        toată piața și să te ajutăm să alegi ce e bine pentru tine.
                    </p>
                    <p className="text-base lg:text-lg text-[#1a1a1a]/70 mb-6">
                        Fără presiuni, fără termeni mărunți ascunși, fără surprize.
                    </p>
                    <p className="text-sm text-[#1a1a1a]/65 italic">
                        Activăm ca asistenți în brokeraj pentru <strong className="not-italic font-semibold text-[#0d3d2e]">Safety Broker de Asigurare S.A.</strong> —
                        broker autorizat ASF, parte a grupului global Acrisure, cu peste 25 de ani
                        de experiență și acoperire națională în România.
                    </p>
                </div>

                <div className="lg:col-span-6 lg:col-start-7">
                    <div className="rounded-2xl border border-[#0d3d2e]/15 p-8 lg:p-10 bg-white">
                        <div className="font-display text-2xl text-[#0d3d2e] mb-6">Ce primești de la noi</div>
                        <ul className="space-y-4">
                            {reasons.map((r, i) => (
                                <li key={i} className="flex gap-3 items-start" data-testid={`reason-${i}`}>
                                    <span className="mt-1 h-5 w-5 rounded-full bg-[#0d3d2e] text-[#fcfbf8] flex items-center justify-center flex-shrink-0">
                                        <Check className="h-3 w-3" strokeWidth={2.5} />
                                    </span>
                                    <span className="text-[#1a1a1a]/80">{r}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
}
